import consumer from './consumer';

if (document.querySelector('.new-candidates-controller-js .cv-parser-container')) {
  window.CVParserChannelConnected = false;

  const currentCompanyId = document.querySelector('meta[name="current-company-id"]').content;

  consumer.subscriptions.create(
    {
      channel: 'CvParserChannel',
      company_id: currentCompanyId,
    },
    {
      connected() {
        window.CVParserChannelConnected = true;
      },
      disconnected() {
        window.CVParserChannelConnected = false;
      },
      received(data) {
        if (data.status === 'success') {
          window.Bizneo.candidates_controller.successCvParser(data);
        } else {
          window.Bizneo.candidates_controller.errorCvParser();
        }
      },
    },
  );
}
